import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-3" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "tw-flex tw-items-center tw-gap-1" }
const _hoisted_4 = {
  key: 0,
  class: "tw-px-2 tw-text-sm tw-text-slate-500"
}
const _hoisted_5 = ["onClick", "disabled"]
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-px-3 tw-py-2 tw-text-sm tw-text-slate-700 hover:tw-bg-white disabled:tw-opacity-60 disabled:tw-cursor-not-allowed",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('previousPage'))),
      disabled: _ctx.disabled || _ctx.page <= 0
    }, " Prev ", 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationItems, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: String(item)
        }, [
          (item === 'ellipsis')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "…"))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: _normalizeClass(["tw-rounded-lg tw-border tw-px-3 tw-py-2 tw-text-sm tw-transition disabled:tw-opacity-60 disabled:tw-cursor-not-allowed", item === _ctx.page
            ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
            : 'tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-text-slate-700 hover:tw-bg-white']),
                onClick: ($event: any) => (_ctx.$emit('goToPage', item)),
                disabled: _ctx.disabled || item === _ctx.page
              }, _toDisplayString(item + 1), 11, _hoisted_5))
        ], 64))
      }), 128))
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-px-3 tw-py-2 tw-text-sm tw-text-slate-700 hover:tw-bg-white disabled:tw-opacity-60 disabled:tw-cursor-not-allowed",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('nextPage'))),
      disabled: _ctx.disabled || _ctx.page + 1 >= _ctx.totalPages
    }, " Next ", 8, _hoisted_6)
  ]))
}